/*
 * These form validator settings could be simplified once we fully switch over to custom forms. 
 * See references to the function isCustomForm for those opportunities.
 */

var $ = require('jquery');
var WS = require('./ws');
require('jquery-validation');

$(function () {
    var $recaptchaResponse;
    var $submitButton;
    var submitButtonSelector = ":submit";
    var iframeIntervalId = "";
    var count = 0;
    var submitting = false;

    $.validator.setDefaults({
        ignore: WS.isExperienceEditor() ? '*' : ':hidden:not([name="RecaptchaResponse"]), .hidden, .ws-form__element--ignore-validation',
        onclick: function (element) {
            // this custom onclick method prevents select elements from immediately being validated
            // as soon as the user clicks on them. this was causing an error to appear when a required
            // select was first clicked. ideally, we'd want to suppress validation on selects when the
            // click causes the list of options to be shown while still validating once the user selects
            // an option. but reliably differentiating between the two cases seems problematic.
            if (element.tagName.toLowerCase() !== 'select' && element.name in this.submitted) {
                this.element(element);
            }
        },
        highlight: function (element) {
            $(element).closest('.ws-material-group').addClass('ws-material-group--theme_error');
            if (!validateOnBlur(element.form)) {
                toggleDisableSubmit(element.form, true);
            }
        },
        unhighlight: function (element) {
            var closestElement = $(element).closest('.ws-material-group');
            toggleAriaAttributes(element, true);
            closestElement.removeClass('ws-material-group--theme_error');

            if (!validateOnBlur(element.form)) {
                validateAllFields(element.form);
            }

            // do not add valid styling for the RecaptchaResponse or for (valid) empty textboxes
            var jqElement = $(element);
            if (jqElement.hasClass('ws-recaptcha__response') ||
                (
                    (
                        jqElement.is('input[type=text]') ||
                        jqElement.is('input[type=number]') ||
                        jqElement.is('input[type=tel]') ||
                        jqElement.is('input[type=email]') ||
                        jqElement.is('textarea')
                    ) &&
                    jqElement.val().length < 1
                )) {
                return;
            }
        },
        errorElement: 'p',
        errorClass: 'ws-material-group__error-message',
        errorPlacement: function (error, element) {
            if (element.parent('.ws-material-group').length) {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        },
        focusInvalid: false,
        onkeyup: function (element, event) {
            // for custom forms, we only want to validate on blur
            if (validateOnBlur(element.form)) {
                return;
            }

            // Avoid revalidate the field when pressing one of the following keys
            // Shift       => 16
            // Ctrl        => 17
            // Alt         => 18
            // Caps lock   => 20
            // End         => 35
            // Home        => 36
            // Left arrow  => 37
            // Up arrow    => 38
            // Right arrow => 39
            // Down arrow  => 40
            // Insert      => 45
            // Num lock    => 144
            // AltGr key   => 225
            var excludedKeys = [
                16, 17, 18, 20, 35, 36, 37,
                38, 39, 40, 45, 144, 225
            ];

            if (event.which === 9 && this.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) {
                return;
            } else if (element.name in this.submitted || element.name in this.invalid) {
                this.element(element);
            }
        },
        submitHandler: function (form) {
            $submitButton = $(this.submitButton);
            var submitValidation = $submitButton.attr("formnovalidate");
            if (submitting && submitValidation === undefined) {
                submitting = false;
                return false;
            }
            submitting = true;
            requestAnimationFrame(function () {
                // adding aria-hidden to the recaptcha prevents screen readers from reading the recaptcha content post-submission
                $(form).find(".ws-recaptcha__g").attr("aria-hidden", true);
                validateOnBlur(form) ? toggleLoadingSubmit(form, true) : toggleDisableSubmit(form, true);
            });

            $submitButton = $(this.submitButton);

            if (submitValidation !== undefined) {
                addHeaderCallBlockPhoneNumber(form);
                submitting = false;
                return true;
            }

            $recaptchaResponse = $(form).find('.ws-recaptcha__response');
            if ($recaptchaResponse.length > 0 && typeof grecaptcha !== "undefined") {
                let recaptchaWidgetId = $(form).data("recaptchaWidgetId");
                grecaptcha.execute(recaptchaWidgetId);

                //this is a hack to reset the recaptcha IFRAME when it scrolls off the page
                iframeIntervalId = setInterval(checkForIframe, 30);
            } else {
                addHeaderCallBlockPhoneNumber(form);
                submitting = false;
                return true;
            }
        }
    });

    function validateOnBlur(form) {
        return $(form).find(".ws-form--custom").length || $(form).find(".ws-form--validate_on-blur").length;
    }

    function checkForIframe() {
        var $element = $("iframe[title='recaptcha challenge']").parent().parent();
        if ($element.length) {
            var bodyPosition = $("body").offset().top; // this accounts for when a modal is displayed, body is made fixed and offset to lock scrolling
            var scroll = $(window).scrollTop() - bodyPosition;
            var position = $element.offset().top;

            //if top position is less than scrollTop of window the IFRAME for recaptcha is rolled up past the view
            if (scroll > position) {
                $element.css({ 'top': scroll + 50 });
            }

            //put this in because the original setting is fine - recaptcha moves it after it is set - this allows time to move it a second time
            count++;
            if (count > 10) {
                stopSetInterval();
                //reset the count field in case the user does not move forward
                count = 0;
            }
        }
    }

    function stopSetInterval() {
        clearInterval(iframeIntervalId);
    }

    window.onSubmitRecaptcha = function (token) {
        stopSetInterval();
        submitting = false;

        if (token) {
            $recaptchaResponse.val(token);

            // once recaptcha has finished, simulate a click on the submit button again so that the ajax submit
            // process works as it should if ajax is enabled for this form. add the formnovalidate parameter so
            // that validation will be skipped the second time around
            $submitButton
                .prop("disabled", false)
                .attr("formnovalidate", "formnovalidate")
                .click();
        }
    } 

    function toggleDisableSubmit(formElement, disable) {
        let $submit = $(formElement).find(submitButtonSelector);
        $submit
            .prop("disabled", disable)
            .toggleClass("ws-btn--disabled", disable);
    }

    function toggleLoadingSubmit(formElement, disable) {
        let $submit = $(formElement).find(submitButtonSelector);
        let buttonClickedName = $(formElement).data("ws-button-clicked");

        $submit
            .prop("disabled", disable)
            .filter(`button[name="${buttonClickedName}"]`)
            .toggleClass("ws-btn--loading", disable);
    }

    function validateAllFields(formElement) {
        if (!$(formElement).hasClass('ws-recaptcha__response')) {
            var validator = $(formElement).validate();

            if (validator) {
                var valid = validator.checkForm();
                toggleDisableSubmit(formElement, !valid);
            }
        }
    }

    function addHeaderCallBlockPhoneNumber(form) {
        var headCallBlockPhoneNumberId = "";
        var $headerCallBlock = $(".ws-call-cta--header");

        if ($headerCallBlock.length > 0) {
            headCallBlockPhoneNumberId = $headerCallBlock.first().data("phoneNumberId");
        }

        if (!headCallBlockPhoneNumberId) {
            return;
        }

        var paramName = "HeaderCallBlockPhoneNumberId";
        var $form = $(form);
        var $phoneNumberIdParam = $form.find('input[name="' + paramName + '"]');

        if ($phoneNumberIdParam.length < 1) {
            $phoneNumberIdParam = $('<input type="hidden" name="' + paramName + '" />');
            $form.append($phoneNumberIdParam);
        }

        $phoneNumberIdParam.val(headCallBlockPhoneNumberId);
    }
    function toggleAriaAttributes(element, isValid) {
        if (isValid) {
            $(element).removeAttr("aria-describedby");
        }
    }
});